export default __webpack_public_path__ + "static/media/RakshabandanNew6.4621b5fe.png";